import React from 'react';
import './CustomInput.scss';

interface CustomInputProps {
  label: string;
  value: string;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CustomInput: React.FC<CustomInputProps> = ({ label, value, onChange, disabled }) => {
  return (
    <div className="custom-input-container">
      <label className="custom-input-label">{label}</label>
      <input
        type="text"
        className="custom-input"
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};